import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import StatStrip from './components/StatStrip';
import About from './components/About';
import Builds from './components/Builds';
import Reviews from './components/Reviews';
import Contact from './components/Contact';
import Footer from './components/Footer';
import BniPage from './pages/BniPage';
import BookPage from './pages/BookPage';
import './App.css';

function HomePage() {
  return (
    <div className="site-shell">
      <Header />
      <main>
        <div className="page-width">
          <Hero />
        </div>
        <StatStrip />
        <div className="page-width">
          <About />
          <Builds />
          <Reviews />
        </div>
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/bni" element={<BniPage />} />
        <Route path="/book" element={<BookPage />} />
        <Route path="*" element={<HomePage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;